export const REGEX = {
  EnvironmentNameRegex: /^[a-z0-9]([-a-z0-9]*[a-z0-9])?(\.[a-z0-9]([-a-z0-9]*[a-z0-9])?)*$/,
  CloudEnvDescriptions:/^$|^.{3,}$/
};
